import { Injectable } from '@angular/core';
import { ConsumeService } from './consume.service';
import { Observable, map, of } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { IRangeHitch, IRangeHitchRange } from '../model/http/IRangeHitch';
import { ICreditGPSRequired, ICreditGPSRequiredResponse } from '../model/http/ICreditGPSRequired';
import { IServicesCreditPlus, IServicesPlus } from '../model/http/servicesPlus.model';

@Injectable({
  providedIn: 'root'
})
export class CotizadorCreditoService {

  constructor(private consume: ConsumeService) {}
  
  //? TRADICIONAL

  getRangeHitchTraditional(params:{
    carId: string,
    customerTypeId: string,
    productTypeId: string,
  }): Observable<IRangeHitch> {
    return this.consume
      .httpGet<IRangeHitchRange>(
        `${Endpoints.cotizadorV3.base}/maximum-down-payment`,
        params
      )
      .pipe(map((resp) => resp.data));
  }

  getCreditGPSRequired(params:{
    carId: string,
    customerTypeId: string,
    downPayment: number,
  }): Observable<boolean> {
    // return of(params.downPayment > 174315 ? false : true);
    return this.consume
      .httpGet<ICreditGPSRequiredResponse>(
        `${Endpoints.cotizadorV3.base}/validate-credit-gps`,
        params
      )
      .pipe(map((resp) => resp.data.gpsRequired));
  }

  generateCreditQuoter(request: any): Observable<any> {
    return this.consume
      .httpPost(`${Endpoints.cotizadorV3.base}/credit_quoter`, request)
      .pipe(map((resp: any) => resp.data));
  }

  getRangeHitchBallon(params: {
    carId: string,
    customerTypeId: string,
    productTypeId: string,
    downPayment: number,
    code?: string,
    ballon: number
  }): Observable<IRangeHitch> {
    return this.consume
      .httpGet<IRangeHitchRange>(
        `${Endpoints.cotizadorV3.base}/maximum-down-payment`,
        params
      )
      .pipe(map((resp) => resp.data));
  }

  getRangeAnnuity(
    carId: string,
    customerTypeId: string,
    productTypeId: string,
    downPayment: number
  ): Observable<any> {
    return this.consume
      .httpGet(
        `${Endpoints.cotizadorV3.base}/maximun-annuality?carId=${carId}&customerTypeId=${customerTypeId}&productTypeId=${productTypeId}&downPayment=${downPayment}`
      )
      .pipe(map((resp: any) => resp.data));
  }

  getRangeBallon(params: {
    carId: string,
    customerTypeId: string,
    code: string,
    downPayment: number
  }): Observable<any> {
    return this.consume
      .httpGet(
        `${Endpoints.cotizadorV3.base}/maximum-ballon`,
        params
      )
      .pipe(map((resp: any) => resp.data));
  }



  getServicesPlus({
    carId,
    km,
    cTiD,
    typeSuitCar,
    stateId,
    insurance,
    cpTip,
    quoterType,
    downPayment,
    insuranceType
  }: IServicesCreditPlus): Observable<any> {

    return this.consume
      .httpGet(
        `${Endpoints.cotizadorV3.base}/services-credit-plus`,
        {
          carId,
          km,
          customerTypeId: cTiD,
          typeSustituteCar: typeSuitCar,
          stateId,
          insurance,
          cpTip,
          quoterType,
          downPayment,
          insuranceType
      })
      .pipe(map((resp: any) => resp));
  }
  
}
